<template>
  <div>
    <div class="head-btns">
      <div class="mwow-button-filled success" @click="openListingDialog">
        一键排课
      </div>
      <div v-if="multipleSelection.length > 0" style="display: inline-block">
        <el-popover
          placement="bottom"
          width="70"
          trigger="click"
          :visible-arrow="false"
          popper-class="no-padding"
          :disabled="multipleSelection.length === 0"
        >
          <slot>
            <div class="muti-buttons">
              <muti-edit-time
                :ori="multipleSelection"
                :cid="Number($route.query.id)"
                @change="handleRefresh"
              >
                <div class="btn">上课时间</div>
              </muti-edit-time>
              <muti-edit-course
                :ori="multipleSelection"
                :cid="Number($route.query.id)"
                @change="handleRefresh"
              >
                <div class="btn">排课课程</div>
              </muti-edit-course>
              <muti-edit-teacher
                :ori="multipleSelection"
                :cid="Number($route.query.id)"
                @change="handleRefresh"
              >
                <div class="btn">教师与授课模式</div>
              </muti-edit-teacher>
              <muti-edit-class-room
                :ori="multipleSelection"
                :cid="Number($route.query.id)"
                @change="handleRefresh"
              >
                <div class="btn">上课教室</div>
              </muti-edit-class-room>
            </div>
          </slot>
          <div slot="reference" class="mwow-button-filled primary">
            批量修改<i class="el-icon-arrow-down" style="margin-left: 8px"></i>
          </div>
        </el-popover>
      </div>
      <div v-else style="display: inline-block">
        <div
          class="mwow-button-filled"
          style="
            background: #f5f7fa !important;
            border-color: #f5f7fa !important;
            color: #c2c3c4 !important;
          "
        >
          批量修改<i class="el-icon-arrow-down" style="margin-left: 8px"></i>
        </div>
      </div>
      <div
        :class="`mwow-button-filled ${
          multipleSelection.length > 0 ? 'danger' : 'del'
        }`"
        @click="handleMultiDelete"
      >
        删除
      </div>
    </div>
    <common-search-form-wrapper :reset="handleSearchReset">
      <el-form size="mini" :model="searchInfo" label-width="75px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="授课教师:" prop="teacher_id">
              <common-staff-pull-down
                :originId.sync="searchInfo.teacher_id"
                :jobIds="[1]"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="上课日期:">
              <!-- <el-date-picker
                v-model="searchInfo.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="handleSearch"
              >
              </el-date-picker> -->
              <common-date-range-selector
                v-model="searchInfo.date"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="handleSearch"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="星期:">
              <el-select
                v-model.number="searchInfo.week_day"
                clearable
                @change="handleSearch"
                placeholder="请选择"
              >
                <el-option label="一" :value="1"></el-option>
                <el-option label="二" :value="2"></el-option>
                <el-option label="三" :value="3"></el-option>
                <el-option label="四" :value="4"></el-option>
                <el-option label="五" :value="5"></el-option>
                <el-option label="六" :value="6"></el-option>
                <el-option label="日" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="上课时间:" prop="start_time">
              <step-start-time-select
                :originStart.sync="searchInfo.start_time"
                @handleChange="handleSearchDate"
              ></step-start-time-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="授课模式:" prop="lesson_type">
              <el-radio-group
                v-model="searchInfo.lesson_type"
                @change="handleSearch"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="1">线下</el-radio-button>
                <el-radio-button :label="2">线上</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="排课课程:" prop="course_id">
              <el-select
                v-model="searchInfo.course_id"
                filterable
                clearable
                placeholder="请选择"
                :filter-method="handleSearchCourse"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in courseList"
                  :key="item.course_id"
                  :label="item.title"
                  :value="item.course_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="上课教室:">
              <el-select
                v-model="searchInfo.classroom_id"
                clearable
                placeholder="请选择"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in classRoomList"
                  :key="item.classroom_id"
                  :label="item.name"
                  :value="item.classroom_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      size="mini"
      v-horizontal-scroll
      :data="tableData"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
      :default-sort="{
        order: 'ascending',
        prop: 'full_start_time',
      }"
    >
      >
      <el-table-column
        type="selection"
        width="50"
        align="center"
      ></el-table-column>
      <el-table-column label="授课教师" prop="teacher_list">
        <template slot-scope="scope">
          <span
            class="dot"
            v-for="item in scope.row.teacher_list"
            :key="item.teacher_id"
            >{{ item.name }}</span
          >
          <span v-if="scope.row.teacher_list.length === 0">-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="上课日期"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
        prop="full_start_time"
      >
        <template slot-scope="scope">
          <span>
            {{ scope.row.date }}
            （{{ weekFormat[scope.row.week_day] }}）
          </span>
        </template>
      </el-table-column>
      <el-table-column label="上课时间">
        <template slot-scope="scope">
          {{ scope.row.start_time.slice(0, 5) }}~{{
            scope.row.end_time.slice(0, 5)
          }}
        </template>
      </el-table-column>
      <el-table-column label="授课模式">
        <template slot-scope="scope">{{
          scope.row.lesson_type === 1 ? "线下" : "线上"
        }}</template>
      </el-table-column>
      <el-table-column label="排课课程">
        <template slot-scope="scope">{{
          scope.row.course ? scope.row.course.title : "-"
        }}</template>
      </el-table-column>
      <el-table-column label="上课教室">
        <template slot-scope="scope">
          {{ scope.row.classroom ? scope.row.classroom.name : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="140">
        <template slot-scope="scope">
          <el-button class="mwow-button success" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button class="mwow-button info" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div style="overflow: hidden">
      <el-pagination
        :current-page="page"
        :page-size="pageSize"
        :page-sizes="pageSizeArray"
        :pager-count="5"
        :style="{ float: 'right', padding: '20px' }"
        :total="total"
        @current-change="handlePagerChange"
        @size-change="handlePagerSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <!-- 快速排课 -->
    <el-drawer
      title="班级排课"
      :visible.sync="listingDialogVisible"
      direction="rtl"
      :size="550"
      destroy-on-close
      @close="handleSearch"
    >
      <listing-add
        :selectedTeacher="classData.teacher_list"
        :visible.sync="listingDialogVisible"
        :originData="classData"
      ></listing-add>
    </el-drawer>
    <!-- 排课编辑 -->
    <el-drawer
      title="排课编辑"
      :visible.sync="editDialogVisible"
      direction="rtl"
      :size="550"
      destroy-on-close
      @close="handleRefresh"
    >
      <listing-edit
        :visible.sync="editDialogVisible"
        :aid="currentArrangeId"
        :cr="classRoom"
      ></listing-edit>
    </el-drawer>
    <!-- 课时编辑 -->
    <el-drawer
      title="课时编辑"
      :visible.sync="lessonDialogVisible"
      direction="rtl"
      :size="550"
      destroy-on-close
      @close="handleRefresh"
    >
      <lesson-dialog
        :lid="lessonDialogId"
        :visible.sync="lessonDialogVisible"
        :cr="classRoom"
      ></lesson-dialog>
    </el-drawer>
  </div>
</template>
<script>
import eventBus from "@/utils/bus";
import listingAdd from "./listingAdd.vue";
import listingEdit from "./listingEdit.vue";
import lessonDialog from "../lessonEditDialog.vue";
import { deleteLesson, getLessonList } from "@/api/lesson";
import { classroomSelectListApi } from "@/api/classRoom";
import { getSelectCourseList } from "@/api/globalSearch";
import MutiEditTime from "./mutiEditTime.vue";
import MutiEditCourse from "./mutiEditCourse.vue";
import MutiEditTeacher from "./mutiEditTeacher.vue";
import MutiEditClassRoom from "./mutiEditClassRoom.vue";
import stepStartTimeSelect from "@/components/steStartTimeSelect.vue";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

export default {
  name: "classDetailLog",
  components: {
    listingAdd,
    listingEdit,
    lessonDialog,
    MutiEditTime,
    MutiEditCourse,
    MutiEditTeacher,
    MutiEditClassRoom,
    stepStartTimeSelect,
    CommonSearchFormWrapper,
    commonStaffPullDown,
    commonDateRangeSelector,
  },
  // @Prop() classData!: {};
  props: ["classData"],
  data() {
    return {
      tableData: [],
      searchInfo: {
        lesson_type: -1,
        start_time: "",
        sort_field: "full_start_time",
        sort_type: "asc",
      },
      page: 1,
      pageSize: 10,
      total: 0,
      pageSizeArray: [5, 10, 30, 50, 100],
      classRoomList: [],
      courseList: [],
      listingDialogVisible: false,
      editDialogVisible: false,
      currentArrangeId: 0,
      lessonDialogVisible: false,
      lessonDialogId: 0,
      multipleSelection: [],
      classRoom: {},
      dateList: [
        { key: -1, value: "每天" },
        { key: 1, value: "周一" },
        { key: 2, value: "周二" },
        { key: 3, value: "周三" },
        { key: 4, value: "周四" },
        { key: 5, value: "周五" },
        { key: 6, value: "周六" },
        { key: 0, value: "周日" },
      ],
      weekFormat: {
        0: "日",
        1: "一",
        2: "二",
        3: "三",
        4: "四",
        5: "五",
        6: "六",
      },
    };
  },
  created() {
    this.handleRefresh();
    eventBus.$on("unsigned-list-update", () => {
      this.handleRefresh();
    });
    classroomSelectListApi({
      page: 1,
      page_size: 500,
    }).then((res) => {
      this.classRoomList = res.data.list;
    });
    this.handleSearchCourse();
  },
  methods: {
    handleSearchReset() {
      this.searchInfo = {
        lesson_type: -1,
        start_time: "",
        sort_field: "full_start_time",
        sort_type: "desc",
      };
      this.handleSearch();
    },
    handleSearchCourse(v) {
      getSelectCourseList({
        title: v || "",
        page: 1,
        page_size: 50,
      }).then((res) => {
        this.courseList = res.data.list;
      });
    },

    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    handleRefresh() {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    handleSearchDate(v) {
      this.searchInfo.start_time = v;
      this.handleSearch();
    },
    getList(params) {
      const option = {
        ...params,
        sort_type: this.searchInfo.sort_type,
        sort_field: this.searchInfo.sort_field,
        class_id: Number(this.$route.query.id),
        roll_call_status: 1, // 只展示未点名课次
      };
      if (this.searchInfo.teacher_id) {
        option.teacher_id = this.searchInfo.teacher_id;
      }
      if (this.searchInfo.date) {
        option.start_date = this.searchInfo.date[0];
        option.end_date = this.searchInfo.date[1];
      }
      if (typeof this.searchInfo.week_day === "number") {
        option.week_day = this.searchInfo.week_day;
      }
      if (this.searchInfo.start_time) {
        option.start_time = this.searchInfo.start_time + ":00";
      }
      if (this.searchInfo.lesson_type >= 0) {
        option.lesson_type = this.searchInfo.lesson_type;
      }
      if (this.searchInfo.course_id) {
        option.course_id = this.searchInfo.course_id;
      }
      if (this.searchInfo.classroom_id) {
        option.classroom_id = this.searchInfo.classroom_id;
      }
      getLessonList(option).then((res) => {
        if (res.error_code === 0) {
          this.tableData = res.data.list;
          this.page = res.data.page;
          this.total = res.data.total;
        }
      });
    },
    handleSortChange(e) {
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.searchInfo.sort_field = e.prop;
      this.handleSearch();
    },
    handleDelete(row) {
      this.$confirm(
        `确定删除排课课次？删除后将同时删除待点名列表课次数据且无法恢复。确定要删除？`,
        `删除课次 - ${row.date} 周(${
          ["日", "一", "二", "三", "四", "五", "六"][row.week_day]
        }) ${row.start_time.slice(0, 5)}~${row.end_time.slice(0, 5)}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          iconClass: "mwow-icon-error",
          customClass: "large",
        }
      )
        .then(() => {
          deleteLesson({
            lesson_ids: [row.lesson_id],
            class_id: row.class_id,
          }).then((res) => {
            if (res.error_code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.handleRefresh();
              eventBus.$emit("class-listing-update");
            } else {
              this.$message({
                type: "error",
                message: "删除失败!" + res.message,
              });
            }
          });
        })
        .catch(() => {});
    },
    openListingDialog() {
      this.listingDialogVisible = true;
    },
    handleEdit(row) {
      this.lessonDialogId = row.lesson_id;
      this.lessonDialogVisible = true;
      this.classRoom = row.classroom;
    },
    handleSelectionChange(val) {
      const res = [];
      val.map((item) => {
        res.push(item.lesson_id);
      });
      this.multipleSelection = res;
    },
    handleMultiDelete() {
      if (this.multipleSelection.length === 0) {
        return false;
      }
      this.$confirm(
        "确定删除排课课次？删除后将同时删除待点名列表课次数据且无法恢复，确定要删除？",
        `删除课次 - 共选择 ${this.multipleSelection.length} 个课次`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          iconClass: "mwow-icon-error",
          customClass: "large",
        }
      )
        .then(() => {
          deleteLesson({
            lesson_ids: this.multipleSelection,
            class_id: Number(this.$route.query.id),
          }).then((res) => {
            if (res.error_code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.handleRefresh();
              eventBus.$emit("class-listing-update");
            } else {
              this.$message({
                type: "error",
                message: "删除失败!" + res.message,
              });
            }
          });
        })
        .catch(() => {});
    },
  },
  beforeDestroy() {
    eventBus.$off("unsigned-list-update");
  },
};
</script>
<style lang="scss" scoped>
.head-btns {
  margin-bottom: 14px;
  .mwow-button-filled {
    margin-right: 20px;
  }
}
.muti-buttons {
  padding: 10px 0;
  .btn {
    padding-left: 10px;
    line-height: 28px;
    font-size: 12px;
    color: #5c5d5e;
    cursor: pointer;
    &:hover {
      background: #f5f7fa;
      color: #07d1aa;
    }
  }
  .dialog-wrap {
    display: block;
  }
}
.dot {
  &::after {
    content: "、";
  }
  &:last-child {
    &::after {
      display: none;
    }
  }
}
</style>
